import { useRef, useEffect } from "react";
/**
 * Sets and removes event listeners
 *
 * @param {string} event         - A string which represents the event to listen
 * @param {Function} callback    - The callback function for the event listener
 * @param {HTMLElement} [target] - Target element (window by default)
 */
const useEventListener = (event, callback, target = window, options) => {
    const savedCallback = useRef();
    /*
     * Updates ref's value if callback changes allowing the effect below to always get the latest callback.
     * This avoids having to pass it in the effect deps preventing it from running on every render.
     */
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        const supportsEventListener = target && target.addEventListener;

        if (!supportsEventListener) return;

        const eventListener = event => savedCallback.current(event);
        target.addEventListener(event, eventListener, options);
        return () => target.removeEventListener(event, eventListener, options);
    }, [event, target, options]);
};
export default useEventListener;